module.exports = __webpack_public_path__ + "img/Total Lights Icon.b6bf6378.png";